import { cn } from "@theprelude/core";
import { InfoIcon } from "@theprelude/ds";
import { DefaultTooltip } from "../default-tooltip";

export const Unavailable: React.FC = () => {
  return <div className="text-secondary-foreground">Unavailable</div>;
};

export const None: React.FC = () => {
  return <div className="text-shingle-grey">None</div>;
};

export const NullOrUnavailable: React.FC<{
  value: null | undefined;
}> = ({ value }) => {
  if (value === null) {
    return (
      <div className="flex items-center gap-1 text-secondary-foreground">
        <Unavailable />
        <DefaultTooltip content="The control is installed on this endpoint, but the value is null">
          <InfoIcon className="h-4 w-4" />
        </DefaultTooltip>
      </div>
    );
  }

  return <Unavailable />;
};

export const NotApplicable: React.FC<{
  className?: string;
}> = ({ className }) => {
  return <div className={cn("text-secondary-foreground", className)}>N/A</div>;
};
